import { useDateFormatter } from '@mint-lib/formatting-hooks';
import { Calendar } from '@mint-lib/icons';
import { parseISO } from 'date-fns';

import { Chip } from '../../lib/chip.jsx';

type DateRangeChipProps = {
  dateFrom: string;
  dateTo: string;
};

const DateRangeChip = ({ dateFrom, dateTo }: DateRangeChipProps) => {
  const formatter = useDateFormatter(parseISO(dateFrom), parseISO(dateTo));

  return (
    <Chip variant="outline" color="silver">
      <Calendar />
      {formatter.formattedDateRange}
    </Chip>
  );
};

export default DateRangeChip;
